
export const ProductTypeModel: Array<any> = [
    {
        label: 'Product Id',
        key: 'key'
    },
    {
        label: 'Product Name',
        key: 'label'
    },
];

export const OrganizationModel: Array<any> = [
    {
        label: 'Integration Client Id',
        key: 'integrationClientId'
    },
    {
        label: 'Class Organization Id',
        key: 'classOrganizationId'
    },
    {
        label: 'Class Organization Name',
        key: 'classOrganizationName'
    },
];
